// Enhances a promise-returning function with fetch-abort cancellation, by
// injecting a cancellation `signal`.
//
// Useful for react-query cancellation.
//
// You can use a single signal to abort multiple requests! Even parallel ones.
//
// Gotchas:
//
// If you wrap this promise in async-function, or use its `then`, the wrapping
// promise will not have `.cancel` method. It's better to use this
// `withFetchCancel` on the outermost Promise.
const withFetchCancel = promiseMaker => {
  const controller = new AbortController()

  const promise = promiseMaker(controller.signal)
    // Swallow exception if catching an abort
    .catch(e => {
      if (!(e instanceof DOMException && e.name === 'AbortError')) {
        throw e
      }
    })

  promise.cancel = () => {
    controller.abort()
  }

  return promise
}

export default withFetchCancel
